<div>
    <!-- <div class="row ">
        <span class="float-right ml-auto" style="margin-right: 85px;">
            <button class="ml-2 mb-4 btn btn-browse" type="button" [routerLink]="'/admin/add-message-guide'">Add Message Guide</button>
        </span>
    </div> -->

    <app-error-guide-table></app-error-guide-table>
</div>